module.exports = __webpack_public_path__ + "img/S.1344e8a.jpg";